import { useMemo } from "react";
import moment from "moment-timezone";
import { last } from "lodash-es";
import { SessionDataType, useSchedulerStore } from "../state/scheduler.store";

const formatPrevSlot = (
  slots: SessionDataType["prevSelectedSlot"],
  fallbackDuration?: number
) => {
  const prevSelectedSlot = last(slots);
  const prevSelectedDuration = prevSelectedSlot?.duration ?? fallbackDuration;

  return {
    previouslySelectedTime: prevSelectedSlot
      ? `${moment(prevSelectedSlot.day)
          .tz("utc")
          .add(prevSelectedSlot.hour, "hour")
          .add(prevSelectedSlot.minute, "minutes")
          .format("llll")} (${prevSelectedSlot.timeZone})`
      : null,
    prevSelectedDuration
  };
};

export const usePreviousSlot = () => {
  const { sessionData, meetingLink } = useSchedulerStore();

  const { previouslySelectedTime, prevSelectedDuration } = useMemo(
    () =>
      formatPrevSlot(
        sessionData?.prevSelectedSlot,
        meetingLink?.availability?.duration
      ),
    [sessionData, meetingLink?.availability?.duration]
  );

  return { previouslySelectedTime, prevSelectedDuration };
};

// Confirmation screen only. Reads the FROM-slot snapshot taken at schedule
// success; falls back to prevSelectedSlot for states that don't snapshot
// (in-progress scheduling, cancelled, initial load) — where prevSelectedSlot
// is still the correct, un-overwritten value.
export const useConfirmationPrevSlot = () => {
  const { sessionData, meetingLink } = useSchedulerStore();

  const { previouslySelectedTime, prevSelectedDuration } = useMemo(
    () =>
      formatPrevSlot(
        sessionData?.confirmationPrevSlot ?? sessionData?.prevSelectedSlot,
        meetingLink?.availability?.duration
      ),
    [sessionData, meetingLink?.availability?.duration]
  );

  return { previouslySelectedTime, prevSelectedDuration };
};
